<template>
  <div class="content rewards">
    <div class="container-fluid">
      <card>
        <template slot="header">
          <div class="row">
            <div class="col">
              <header-navigator :routes="headerTitleData.data"></header-navigator>
            </div>
          </div>
        </template>
        <template>
          <div class="reward" v-for="item in rewards" :key="item.title">
            <div class="reward-title">
              <router-link to="/reward/edit" @click.native="setRewardBeingEdited(item)">{{item.title}}</router-link>
              <p>Last edited on {{item.last_edited}}</p>
            </div>
            <div class="row reward-details">
              <div class="col options">
                <discard-button :buttonText="restore_text" :processing-click="attempting_restore" v-on:onButtonClicked="onRestoreClicked(item)"/>
              </div>
            </div>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
  import Card from '@/components/UIComponents/Cards/Card.vue'
  import HeaderNavigator from '@/components/UIComponents/HeaderNavigator.vue'
  import DiscardButton from '@/components/UIComponents/Buttons/DiscardButton.vue'

  export default {
    components: {
      Card,
      HeaderNavigator,
      DiscardButton,
    },
    data () {
      return {
        archived_text: "ARCHIVED",
        restore_text: "RESTORE",
        attempting_restore: false,
        headerTitleData: {
          data: [
            {title: 'Manage Rewards', route: '/rewards'},
            {title: 'Archived', route: '/rewards/archived'},
          ]
        },
      }
    },
    methods: {
      async onRestoreClicked(reward) {
        const payload = {
          is_archived: false,
          merchant_id: this.$store.getters.advertiser.id,
          reward_id: reward.id,
        }
        this.attempting_restore = true;
        await this.$store.dispatch('uploadRewardArchivedStatus', payload);
        this.attempting_restore = false;

        this.goToRewardManager();
      },
      setRewardBeingEdited (reward) {
        this.$store.dispatch('setRewardBeingEdited', reward)
      },
      goToRewardManager() {
        this.$store.dispatch('setModalTitle', { title: "Reward Restored!" })
        this.$store.dispatch('setSVGType', { svg_type: 'checkmark' })
        this.$store.dispatch('setModalMessage', { message: "redirecting..." })
        this.$store.dispatch('setModalVisible', { visible: true })
        const self = this;
        setTimeout(function () { 
            self.$router.push('/rewards'); 
            self.$store.dispatch('setModalVisible', { visible: false });
          }, 2000)
      },
    },
    computed: {
      rewards() {
        return this.$store.getters.archivedRewards;
      },
    }, 
    mounted () {
      this.$nextTick(() => {
        this.$emit('scrollTop', 0)
      });
    }
  }
</script>
